import Auth from './Auth'
import User from './User'
import Blog from './Blog'
import Community from './Community'
import Application from './Application'
import Payment from './Payment'
import Motd from './Motd'
import Stats from './Stats'
import Ticket from './Ticket'
import Settings from './Settings'
import Config from './Config'
import Template from './Template'

export default {
  Auth,
  User,
  Blog,
  Community,
  Application,
  Payment,
  Motd,
  Stats,
  Ticket,
  Settings,
  Config,
  Template
}



// WEBPACK FOOTER //
// ./src/stores/index.js